// @flow strict

import type {FlowBuilder} from 'src/types/flow-builder';
import type {FlowBuilderActions} from 'src/action-creators/flow-builder';

import {
  UPDATE_FLOW_BUILDER,
  RESET_FLOW_TEMPLATES,
  UPDATE_AGENT_SETTINGS,
} from 'src/action-creators/flow-builder';


export type FlowBuilderState = {
  ...FlowBuilder,
};

const initialState = {
  templates: [],
  preview_template_id: null,
  template_name: null,
  // TODO(darsh): create a dummy workstream
  workstream: null,
  workstream_name: null,
  isWorkstreamLoading: false,
  agentSettings: {
    voiceBot: {
      selectedVoice: null,
      selectedBrand: null,
      selectedLanguage: null,
      selectedRole: null,
      responsiveness: null,
      voiceSpeed: null,
      speechNormalization: false,
    },
    voicemail: {
      voicemailDetection: false,
      voicemailAction: null,
      voicemailDuration: null,
      message: null,
    },
    additionalContext: {
      selectedIndustry: null,
      jobSpecialities: [],
    },
  },
};

export default (
  state: FlowBuilderState = initialState,
  action: FlowBuilderActions,
): FlowBuilderState => {
  switch (action.type) {
    case UPDATE_FLOW_BUILDER: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case RESET_FLOW_TEMPLATES: {
      return {
        ...state,
        templates: [],
        preview_template_id: null,
      };
    }

    case UPDATE_AGENT_SETTINGS: {
      const current = state.agentSettings || {};
      const payload = action.payload || {};

      return {
        ...state,
        agentSettings: {
          voiceBot: {
            ...(payload.agentSettings.voiceBot ?? current.voiceBot ?? {}),
          },
          voicemail: {
            ...(payload.agentSettings.voicemail ?? current.voicemail ?? {}),
          },
          additionalContext: {
            ...(payload.agentSettings.additionalContext ??
              current.additionalContext ??
              {}),
          },
        },
      };
    }
  }
  return state;
};
